var _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#2B2C33"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.125,
    cy: 7.125,
    r: 1.125,
    fill: "#757575"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.125,
    r: 1.125,
    fill: "#757575"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.875,
    cy: 7.125,
    r: 1.125,
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step 2.162b7427a3edbfda88ee11faa8cdf36d.svg";
export { ForwardRef as ReactComponent };